import { getUsers } from '@/api/user';
import type { User } from '@/types/User';

/** Return a complete option set; never resolve a partially loaded directory. */
export async function getProjectSelectorUsers(): Promise<User[]> {
  const users = new Map<number, User>();
  for (let page = 1; ; page += 1) {
    const response = await getUsers({ params: { active: 'true', perPage: 20, page } });
    const total = response.meta.total;
    if (!Number.isSafeInteger(total) || total < 0) {
      throw new Error('Invalid user pagination total.');
    }
    const previousSize = users.size;
    for (const user of response.data) {
      if (!users.has(user.id)) users.set(user.id, user);
    }
    if (users.size >= total) return [...users.values()];
    if (users.size === previousSize) {
      throw new Error('Unable to load the complete user directory. Please retry.');
    }
  }
}
